<template>
    <img
        alt="Logo"
        class="shadow-lg rounded-md h-16 p-2 object-contain"
        src="/logo.png"
    />
</template>
